import React from 'react';
import PreviewErrorCard from './PreviewErrorCard.tsx';

export class PreviewErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-state
    this.state = { hasError: false, error: null };
    const { errorHandler } = props;
    errorHandler.errorHandler = this.handleError.bind(this);
    errorHandler.clearError = this.clearError.bind(this);
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // TODO: log the error to an error reporting service
    // eslint-disable-next-line no-console
    console.error(error, errorInfo);
  }

  handleError(error) {
    this.setState({ hasError: true, error });
  }

  clearError() {
    this.setState({ hasError: false, error: null });
  }

  render() {
    const { state, props } = this;

    if (state.hasError) {
      // eslint-disable-next-line no-console
      console.error(state.error);
      return <PreviewErrorCard />;
    }

    return props.children;
  }
}
